<template>
	<div class="w-100 p-3 bg-white border-15 overflow-auto">
		<table class="table">
			<tr class="border">
				<td class="bMikhak p-3 text-center">
					نوع کلاس
				</td>
				<td class="bMikhak p-3 text-center">
					تاریخ
				</td>
				<td class="bMikhak p-3 text-center">
					بازه زمانی
				</td>
				<td class="bMikhak p-3 text-center">
					کل جلسات
				</td>
				<td class="bMikhak p-3 text-center">
					فروخته شده
				</td>
				<td class="bMikhak p-3 text-center">
					جلسات‌ غیرفعال
				</td>
				<td class="bMikhak p-3 text-center">
					وضعیت
				</td>
				<td class="bMikhak p-3 text-center">
					مدیریت
				</td>
			</tr>
			<tr v-for="(f, i) in flds.content" :key="i">
				<td class=" yekan">
					{{f.knd_class}}
				</td>
				<td class="text-center yekan">
					{{f.date_class}}
				</td>
				<td dir="ltr" class="yekan text-center">
					{{f.timeRange.start}} - {{f.timeRange.end}}
				</td>
				<td class="yekan text-center">
					{{f.cnt_class}}
				</td>
				<td class="yekan text-center">
					{{f.cnt_reserved}}
				</td>
				<td class="yekan text-center">
					{{f.cnt_disable}}
				</td>
				<td class="text-center text-danger" v-if="f.status==0">
					غیر فعال
				</td>
				<td class="text-center text-success" v-if="f.status==1">
					فعال
				</td>
				<td class="text-center">
					<router-link
						class="text-orange"
						style="font-size: 14px; text-decoration: underline;"
						:to="'/class/update/'+f.id"
					>
						ویرایش
					</router-link>
					<hr class="m-0"/>
					<label 
					:for="'calender_'+f.id"
					class="m-0 text-primary pointer"
					style="font-size: 14px;"
					>
						تکرار
					</label>
					<inputcalender
						:random_id="f.id"
						textClass="pointer text-center"
						input_style="padding: 0px !important; height: 0px !important;"
						leading=""
						placeholder="تکرار"
						label=""  
						style="width:0px!important"
						@inputdate="(e)=>{setDate(e, i)}"
					/>
				</td>
			</tr>
		</table>
		<br/>
		<br/>
		<div class="w-100" style="display: flex; align-items: center; justify-content: center;">
			<pageNavigation :page="flds.curPage" :pages="flds.totalPages" @setPage="setPage"  />
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import inputcalender from  "../../UI/calendar/inputcalender.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";

		export default {
			name: 'class_list_part1',
			data(){
				return {}
			},
			components: {
				btn,
				inputcalender,
				pageNavigation,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){

			},
			methods:{
				setDate(date, i){
					let html = "<p>مدرس گرامی؛</p>";
					html += "<p>کلاس‌های <b class='text-danger'>"+this.flds.content[i].knd_class+"</b> شما در روز <b class='text-danger'>"+this.flds.content[i].date_class+"</b> برای روز <b class='text-danger'>"+date+"</b> تکرار خواهد شد</p>";

					this.$swal.fire({
						position: 'center',
						type: '',
						html: html,
						title: 'تکرار',
						showCloseButton: true,
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: "بلی",
						confirmButtonColor: "#0d5048",
						cancelButtonText: 'خیر',
						cancelButtonColor: '#fa6164',
					}).then((result) => {
						if (result.value) {
							this.copyDate(this.flds.content[i].id, date);
						}
					})
				},
				//----------------------------------------------------
				copyDate(id, date, THIS=this){
					let T = (this.$route.params.id == undefined) ? this.$localStorage.get("user").username.id : this.$route.params.id ;
					window.$.post(window.baseurl+'classes/copy', {
						id: id,
						teacher: T, 
						date: date,
						token: this.$localStorage.get("user"),
						role: this.$localStorage.get("user").username.role 
					}, function(D){
						THIS.$emit('load_page')
					}, "json");
				},
				//----------------------------------------------------
				setPage(page){
					this.$emit('setPage', page);
				},
			}
		}
	</script>
<style>

</style>
